import $ from "jquery";
import Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
HighchartsMore(Highcharts);

var $i = 1;
$(".js-hightchar").each(function() {
    var dd = $(this).data("chart");
    var number = [parseInt(dd[0]), parseInt(dd[1]), parseInt(dd[2]), parseInt(dd[4]), parseInt(dd[3])];
    $(this).attr("id", "hight" + $i);
    if (dd) {
        var chart = Highcharts.chart("hight" + $i, {
            chart: {
                polar: true,
                type: 'line'
            },
            width: "100",
            height: "100",
            colors: ['rgba(223,217,192,0.5)'],
            xAxis: {
                gridLineColor: '#969696',
                categories: ['お迎え対応<span>' + dd[0] + '</span>', '<span class="center">' + dd[1] + '</span>説明', '<span class="center">' + dd[2] + '</span>料金の内容', '<span class="center">' + dd[4] + '</span>スタッフ', '<span class="center">' + dd[3] + '</span>設備'],
                tickmarkPlacement: 'off',
                lineWidth: 0,
                labels: {
                    useHTML: true,
                },
            },
            yAxis: {
                gridLineColor: '#969696',
                gridLineInterpolation: 'polygon',
                lineWidth: 0,
                min: 0,
                max: 5,
                tickInterval: 1,
                labels: {
                    enabled: false
                }
            },
            series: [{
                name: '割り当てられた予算',
                data: number,
                pointPlacement: 'on',
                type: 'area',
                marker: false,
            }],
            legend: {
                enabled: false
            },
            tooltip: {
                enabled: false
            },
            title: {
                text: '',
                style: {
                    display: 'none'
                }
            },
            credits: {
                enabled: false
            },
        });
    }
    $i++;
});
